import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages/ai-config-items';
import TextAdjustLengthIcon from '@atlaskit/icon-lab/core/text-adjust-length';

import { MakeLongerIcon } from '../../../../icons/prompt/makeLonger';
import type { ConvoAiFeatureId } from '../../../../utils/request/types';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptionsFactory,
	EditorPluginAIConfigItemFactory,
} from '../../config-items';

const intentSchemaId = 'make_longer.json';

export const makeLonger: EditorPluginAIConfigItemFactory = (options) => {
	const featureId: ConvoAiFeatureId = 'make_longer_adf_gpt41mini';

	return {
		key: CONFIG_ITEM_KEYS.MAKE_LONGER,
		title: aiConfigItemMessages.makeLongerTitle,
		description: aiConfigItemMessages.makeLongerDescription,
		icon: () => <MakeLongerIcon />,
		statusLozengeType: 'beta',
		intentSchemaId,
		featureId,
		adfPrompt: true,
		requiresTextualContent: true,
		getBackendModel: () => 'assistance-service',
		showInRefineDropdown: true,
		actions: {
			empty: [
				createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
				createReplace({ appearance: 'primary' }),
			],
			selection: [
				createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
				createReplace({ appearance: 'primary' }),
			],
		},
		get nestingConfig() {
			if (options?.isInDocumentStreamingEnabled) {
				return {
					id: 'adjust-length',
					parentTestId: 'adjust-length',
					parentTitle: aiConfigItemMessages.adjustLengthNestingParentTitle,
					shortTitle: aiConfigItemMessages.adjustLengthNestingParentShortTitle,
					icon: () => <TextAdjustLengthIcon label="" spacing="spacious" />,
				};
			}
			return undefined;
		},
	};
};

export const makeLongerWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (options) => ({
	config: makeLonger(options),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
